export const FETCH_ANCILLARY_SUMMARY_REQUEST =
  "fetch/ancillary/summary/request";
export const FETCH_ANCILLARY_SUMMARY_SUCCESS =
  "fetch/ancillary/summary/success";
export const FETCH_ANCILLARY_SUMMARY_FAILURE =
  "fetch/ancillary/summary/failure";
export const FETCH_ANCILLARIES_REQUEST = "fetch/ancillaries/request";
export const FETCH_ANCILLARIES_SUCCESS = "fetch/ancillaries/success";
export const FETCH_ANCILLARIES_FAILURE = "fetch/ancillaries/failure";
export const REDEEM_ANCILLARY_REQUEST = "redeem/ancillary/request";
export const REDEEM_ANCILLARY_SUCCESS = "redeem/ancillary/success";
export const REDEEM_ANCILLARY_FAILURE = "redeem/ancillary/failure";
export const FETCH_ALL_ACCESS_CODE_SUCCESS = "fetch/access_code/success";
export const FETCH_ALL_ACCESS_CODE_FAILURE = "fetch/access_code/failure";
export const FETCH_ALL_ACCESS_CODE_REQUEST = "fetch/access_code/request";
